import { serviceLocator } from '@/utils/providers/serviceLocator'
import { useQuery } from '@/utils/asyncStateManagement/useQuery'
import type { ChannelRepository } from '../repositories/ChannelRepository'

export async function getChannelCase(id: number) {
  const repository = serviceLocator.getService<ChannelRepository>('ChannelService')

  const { data } = await useQuery({
    fetcher: async () => await repository?.getChannel(id),
    key: 'channel',
    filterData: JSON.stringify(id)
  })
  if (data.value?.error) return
  return data.value
}
